import React from 'react';
import PropTypes from 'prop-types';
import { TransactionDetails } from './styled';
import {
  TRANSACTION_DETAILS_GS_QUERY,
  TRANSACTION_DETAILS_WIDGET_SETTINGS,
  TRANSACTION_DETAILS_WIDGET_SETTINGS_PREVENTION,
  SMARTASSESSMENT_TRANSACTION_DETAIL_DOWNLOAD,
  SMARTASSESSMENT_TRANSACTION_DETAIL_PREVENTION_DOWNLOAD
} from './constant';

const TransactionInformatoinTab = ({
  alertId,
  isSmartAssessment,
  isPrevention
}) => (
  <TransactionDetails
    showWidgetActionLabels={false}
    settings={
      isPrevention
        ? TRANSACTION_DETAILS_WIDGET_SETTINGS_PREVENTION
        : TRANSACTION_DETAILS_WIDGET_SETTINGS
    }
    alertId={alertId}
    gsQuery={TRANSACTION_DETAILS_GS_QUERY}
    hasTriggeredOnlySwitch={false}
    requireTriggeredOnlyParam
    csvHeaders={
      isPrevention
        ? SMARTASSESSMENT_TRANSACTION_DETAIL_PREVENTION_DOWNLOAD
        : SMARTASSESSMENT_TRANSACTION_DETAIL_DOWNLOAD
    }
    isSmartAssessment={isSmartAssessment}
    isPrevention={isPrevention}
  />
);

TransactionInformatoinTab.propTypes = {
  alertId: PropTypes.string.isRequired
};

export default TransactionInformatoinTab;
